import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTotal = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_14250_272105)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M28.5247 20.2109H25.3347C24.4363 20.2109 23.6388 20.7059 23.2355 21.5126L22.4655 23.0343C22.2822 23.4009 21.9155 23.6301 21.5122 23.6301H18.5055C18.2213 23.6301 17.818 23.5659 17.5522 23.0343L16.7822 21.5218C16.3788 20.7243 15.5722 20.2201 14.683 20.2201H11.4747C11.1172 20.2201 10.833 20.5043 10.833 20.8618V23.8501C10.833 27.1776 12.8313 29.1668 16.168 29.1668H23.8497C26.9938 29.1668 28.928 27.4434 29.1663 24.3818V20.8526C29.1663 20.5043 28.8822 20.2109 28.5247 20.2109Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M29.1663 16.1591V18.9458C28.9647 18.8724 28.7447 18.8358 28.5247 18.8358H25.3347C23.9138 18.8358 22.6397 19.6241 22.0072 20.8891L21.3197 22.2458H18.698L18.0105 20.8983C17.378 19.6241 16.1038 18.8358 14.683 18.8358H11.4747C11.2547 18.8358 11.0347 18.8724 10.833 18.9458V16.1591C10.833 12.8224 12.8222 10.8333 16.1588 10.8333H23.8405C27.1772 10.8333 29.1663 12.8224 29.1663 16.1591Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_14250_272105",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "matrix(1 0 0 -1 8 32)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgTotal);
export default ForwardRef;
